import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["limit"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getOperationName } from '../../../../common/utils/operation';
import { postResource } from '../../../../utils/fetch';
import { generateActivityQueryWithFilters } from './activities-query';
import { transformActivitiesItems } from './activities-transform';
var ACTIVITIES_LIMIT = 50;

// typescript guard for validating the activities connection type
var isMyActivitiesConnection = function isMyActivitiesConnection(activities) {
  return activities.myActivities !== undefined;
};
var V2_AVAILABLE_PRODUCTS = ['teamCentral', 'editor', 'people', 'jira', 'townsquare', 'apOnboarding', 'worklens', 'confluence', 'start'];
export var fetchActivitiesV2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _response$data;
    var experience, product, retryMS, _ref$filters, filters, activityQueries, baseUrl, _filters$limit, limit, restFilters, _generateActivityQuer, query, queryFilters, operationProduct, response, workedOn, viewed, all;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          experience = _ref.experience, product = _ref.product, retryMS = _ref.retryMS, _ref$filters = _ref.filters, filters = _ref$filters === void 0 ? {} : _ref$filters, activityQueries = _ref.activityQueries, baseUrl = _ref.baseUrl;
          _filters$limit = filters.limit, limit = _filters$limit === void 0 ? ACTIVITIES_LIMIT : _filters$limit, restFilters = _objectWithoutProperties(filters, _excluded);
          experience.mark('GeneratedQueryWithFilters_start');
          _generateActivityQuer = generateActivityQueryWithFilters(product, restFilters, activityQueries), query = _generateActivityQuer.query, queryFilters = _generateActivityQuer.queryFilters;
          experience.mark('GeneratedQueryWithFilters_end');

          // This is to make v2 forwards compatible. Defaulting to start as the product
          operationProduct = V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
          experience.mark('FetchedActivities_start');
          _context.prev = 7;
          _context.next = 10;
          return postResource(baseUrl, {
            operationName: getOperationName(operationProduct),
            query: query,
            variables: {
              first: limit,
              filters: queryFilters
            }
          }, retryMS);
        case 10:
          response = _context.sent;
          _context.next = 17;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](7);
          if (!(!_context.t0 || _context.t0.statusCode !== 401 && _context.t0.message !== 'The operation was aborted.')) {
            _context.next = 17;
            break;
          }
          throw _context.t0;
        case 17:
          experience.mark('FetchedActivities_end');
          workedOn = [], viewed = [], all = [];
          if (!(!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activities))) {
            _context.next = 21;
            break;
          }
          return _context.abrupt("return", {
            all: all,
            workedOn: workedOn,
            viewed: viewed
          });
        case 21:
          experience.mark('TransformedActivityItems_start');
          if (isMyActivitiesConnection(response.data.activities)) {
            if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) {
              workedOn = transformActivitiesItems('workedOn', response.data.activities.myActivities.workedOn);
            }
            if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) {
              viewed = transformActivitiesItems('viewed', response.data.activities.myActivities.viewed);
            }
            if (response.data.activities.myActivities.all && activityQueries.includes('all')) {
              all = transformActivitiesItems('all', response.data.activities.myActivities.all);
            }
          } else {
            if (response.data.activities.workedOn && activityQueries.includes('workedOn')) {
              workedOn = transformActivitiesItems('workedOn', response.data.activities.workedOn);
            }
            if (response.data.activities.all && activityQueries.includes('all')) {
              all = transformActivitiesItems('all', response.data.activities.all);
            }
          }
          experience.mark('TransformedActivityItems_end');
          return _context.abrupt("return", {
            all: all,
            viewed: viewed,
            workedOn: workedOn
          });
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7, 13]]);
  }));
  return function fetchActivitiesV2(_x) {
    return _ref2.apply(this, arguments);
  };
}();